import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
// import FormControlLabel from '@mui/material/FormControlLabel';
// import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import { useTheme, useMediaQuery } from "@mui/material";
import Typography from '@mui/material/Typography';
import Axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { tokens } from "../../theme";
import React from 'react';
import { useSignIn } from 'react-auth-kit';
import jwt_decode from 'jwt-decode';
import CloseIcon from '@mui/icons-material/Close';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { setSessionExpiry } from '../../utils/useSessionExpiry';

const PARENT_PORTAL_URL = process.env.REACT_APP_PARENT_PORTAL_URL || 'http://localhost:5173';

const Signin = () => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const signIn = useSignIn();
    const navigateTo = useNavigate();
    const handleSubmit = (event) => {
        event.preventDefault();
        const data = new FormData(event.currentTarget);

        const email = data.get('email');
        const password = data.get('password');

        if (email === null || email === undefined || email === "") {
            alert("Email is required");
            return;
        } else if (password === null || password === undefined || password === "") {
            alert("Password is required");
            return;
        }

        if (email.length > 50) {
            alert("Email must be less than 50 characters");
            return;
        } else if (password.length > 30) {
            alert("Password must be less than 30 characters");
            return;
        }

        Axios.post(`${process.env.REACT_APP_URL}/api/v1/signin`, {
            email: email,
            password: password,
        }).then((response) => {
            const userName = response.data.userName;
            const decodedToken = jwt_decode(response.data.token);
            const who = decodedToken.who;
            // Now the token has an 'exp' claim you can check
            // const who = jwt_decode(response.data.token).who;

            signIn({
                token: response.data.token,
                expiresIn: response.data.expiresIn,
                tokenType: "Bearer",
                authState: { id: jwt_decode(response.data.token).id, email: data.get('email'), who: jwt_decode(response.data.token).who },
            });

            // 👇️ save user name in local storage for chat
            localStorage.setItem("userName", userName);
            localStorage.setItem("who", who);
            setSessionExpiry(response.data.expiresIn);

            //add timeout for cookie to be set
            setTimeout(()=>{
                if (who === "admin"){
                    navigateTo('/');
                }
                else if (who === "student" || who === "teacher")
                    navigateTo('/classrooms/classes');
            },100);            
        }).catch((error) => {
            alert(error.response?.data?.message || "Something went wrong");
        });
    };

    return (
        <Box
            sx={{
                height: '100%',
                width: '100%',
                display: 'flex',
                justifyContent: 'space-between',
                flexDirection: 'column',
                alignItems: 'center',
            }}
        >
            <div></div>
            <div>
                <Typography variant="h1" style={{ textAlign: 'center' }}>
                    Sign in
                </Typography>
                <Box component="form" onSubmit={handleSubmit} noValidate sx={{ width: isMobile ? '85vw' : '24vw', minWidth: isMobile ? 'auto' : '320px', padding: '1rem' }}>
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        id="email"
                        label="Email Address"
                        name="email"
                        autoComplete="email"
                        autoFocus
                    />
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        name="password"
                        label="Password"
                        type="password"
                        id="password"
                        autoComplete="current-password"
                    />
                    {/* <FormControlLabel
                        control={<Checkbox value="remember" color="primary" />}
                        label="Remember me"
                    /> */}
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        sx={{ mt: 1, mb: 2 }}
                        color='secondary'
                    >
                        <Typography color={colors.primary[400]}>Sign In</Typography>
                    </Button>
                    <Grid container>
                        <Grid item xs>
                            <Link href="/forgot-password" variant="body2">
                                Forgot password?
                            </Link>
                        </Grid>
                        <Grid item>
                            <Link href="/signup" variant="body2">
                                {"Don't have an account? Sign Up"}
                            </Link>
                        </Grid>
                    </Grid>

                    {/* Below Form Portal Link */}
                    <Box
                        sx={{
                            mt: 4,
                            pt: 3,
                            borderTop: `1px solid ${colors.grey[700]}`,
                            textAlign: 'center',
                        }}
                    >
                        <Typography variant="body2" sx={{ color: colors.grey[400], mb: 1 }}>
                            Are you a parent?
                        </Typography>
                        <Link
                            href={PARENT_PORTAL_URL}
                            sx={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: 0.5,
                                color: colors.grey[200],
                                textDecoration: 'none',
                                fontWeight: 500,
                                '&:hover': {
                                    color: colors.grey[400],
                                    textDecoration: 'underline',
                                },
                            }}
                        >
                            Go to Parent Portal
                            <ArrowForwardIcon sx={{ fontSize: '1rem' }} />
                        </Link>
                    </Box>
                </Box>
            </div>
            <div style={{display: "flex", padding: "2rem", gap: "1rem"}}>
                <img
                    alt="ETT logo"
                    width="160px"
                    height="60px"
                    src={`../../imgs/ETT_logo_tran.png`}
                    style={{margin: "auto"}}
                />
                <CloseIcon fontSize='large' sx={{ m: "auto" }} />
                <img
                    alt="solple logo"
                    width="200px"
                    height="64px"
                    src={`../../imgs/aone-logo.png`}
                    style={{margin: "auto"}}
                />
            </div>
        </Box>
    )
}

export default Signin